function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#37559C",
  width: 40,
  height: 40,
  rx: 20
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.667 16.667v-1.985c0-.895.198-1.349 1.588-1.349H25V10h-2.667c-3.333 0-4.666 2.224-4.666 4.667v2H15V20h2.667v10h4V20h2.937L25 16.667h-3.333",
  fill: "#FFF"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IGZpbGw9IiMzNzU1OUMiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIwIj48L3JlY3Q+CiAgICA8cGF0aCBkPSJNMjEuNjY2NjY2NywxNi42NjY2NjY3IEwyMS42NjY2NjY3LDE0LjY4MiBDMjEuNjY2NjY2NywxMy43ODY2NjY3IDIxLjg2NDY2NjcsMTMuMzMzMzMzMyAyMy4yNTUzMzMzLDEzLjMzMzMzMzMgTDI1LDEzLjMzMzMzMzMgTDI1LDEwIEwyMi4zMzMzMzMzLDEwIEMxOSwxMCAxNy42NjY2NjY3LDEyLjIyNCAxNy42NjY2NjY3LDE0LjY2NjY2NjcgTDE3LjY2NjY2NjcsMTYuNjY2NjY2NyBMMTUsMTYuNjY2NjY2NyBMMTUsMjAgTDE3LjY2NjY2NjcsMjAgTDE3LjY2NjY2NjcsMzAgTDIxLjY2NjY2NjcsMzAgTDIxLjY2NjY2NjcsMjAgTDI0LjYwNCwyMCBMMjUsMTYuNjY2NjY2NyBMMjEuNjY2NjY2NywxNi42NjY2NjY3IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };